import { ProgramRegion } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramRegions: (
  fetchContext: FetchContext, 
  programId: number,
  searchText?: string,
  accessToken?: string) => Promise<ProgramRegion[]> = (fetchContext, programId, searchText, accessToken) => {
  const searchParams = new URLSearchParams();
  if (searchText) {
    searchParams.append('searchText', searchText);
  }

  const url = `${fetchContext.baseUrl}/api/staff/programs/${programId}/regions${
    searchParams.size > 0 ? `?${searchParams}` : ''
  }`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<ProgramRegion[]>(fetchContext.errorStore, response, 'get program regions'));
};
